// src/components/Navbar.js (Updated)
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [userRole, setUserRole] = useState('candidate');
  const [userName, setUserName] = useState('User');
  const [userInitials, setUserInitials] = useState('U');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedIn);

    if (loggedIn) {
      const mobile = localStorage.getItem('userMobile');
      const name = localStorage.getItem('userName') || 'User';

      let role = localStorage.getItem('userRole');

      if (mobile === '9876543210') {
        role = 'admin';
        localStorage.setItem('userRole', 'admin');
      } else if (mobile === '9876543299') {
        role = 'super_admin';
        localStorage.setItem('userRole', 'super_admin');
      } else if (!role || role === 'null' || role === 'undefined') {
        role = 'candidate';
        localStorage.setItem('userRole', 'candidate');
      }

      setUserRole(role);
      setUserName(name);

      const names = name.split(' ');
      if (names.length >= 2) {
        setUserInitials(`${names[0][0]}${names[1][0]}`.toUpperCase());
      } else {
        setUserInitials(name.substring(0, 2).toUpperCase());
      }
    }
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setIsProfileDropdownOpen(false);
    setIsMobileMenuOpen(false);
    navigate('/login');
  };

  const navigateTo = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
    setIsProfileDropdownOpen(false);
  };

  // ✅ NEW: Check if button should be active
  const isActive = (path) => {
    // For My Tickets - active on both /user/my-tickets and /user/raise-ticket
    if (path === '/user/my-tickets') {
      return location.pathname === '/user/my-tickets' || 
             location.pathname === '/user/raise-ticket';
    }
    return location.pathname === path;
  };

  // ========== ROLE-BASED BUTTONS ==========

  const adminButtons = [
    { label: 'Dashboard', path: '/admin/dashboard', icon: 'fa-chart-line' },
    { label: 'View Requirement', path: '/admin/view-requirement', icon: 'fa-eye' },
    { label: 'Create Requirement', path: '/admin/create-requirement', icon: 'fa-plus-circle' },
    // { label: 'Communication', path: '/admin/communication', icon: 'fa-comments' },
     { label: 'Candidate List', path: '/admin/candidates', icon: 'fa-users' },
    { label: 'View Application', path: '/admin/view-applications', icon: 'fa-list' },
    { label: 'View Tickets', path: '/admin/tickets', icon: 'fa-ticket-alt' },
    { label: 'Employee Master', path: '/admin/form', icon: 'fa-users-cog' },
  ];

  const externalAdminButtons = [
    { label: 'View Requirement', path: '/external-admin/view-requirement', icon: 'fa-eye' },
    { label: 'View Application', path: '/external-admin/view-applications', icon: 'fa-list' },
    { label: 'Communication', path: '/external-admin/communication', icon: 'fa-comments' },
    { label: 'View Tickets', path: '/admin/tickets', icon: 'fa-ticket-alt' },
  ];

  const candidateButtons = [
    { label: 'View Requirements', path: '/user/view-requirement', icon: 'fa-eye' },
    { label: 'My Applications', path: '/user/applications', icon: 'fa-file-alt' },
    { label: 'My Tickets', path: '/user/my-tickets', icon: 'fa-ticket-alt' },
    { label: 'Profile', path: '/user', icon: 'fa-user' },
  ];

  const superAdminButtons = [
    { label: 'Dashboard', path: '/super-admin', icon: 'fa-chart-line' },
    { label: 'View Tickets', path: '/admin/tickets', icon: 'fa-ticket-alt' },
  ];

  const getNavButtons = () => {
    if (userRole === 'super_admin') return superAdminButtons;
    if (userRole === 'admin') return adminButtons;
    if (userRole === 'external_admin') return externalAdminButtons;
    return candidateButtons;
  };

  const navButtons = getNavButtons();

  const getRoleDisplay = () => {
    const roles = {
      admin: 'Admin',
      external_admin: 'Ext. Admin',
      candidate: 'Candidate',
      super_admin: 'Super Admin'
    };
    return roles[userRole] || 'User';
  };

  // ============================================
  // NAVBAR VISIBILITY RULES
  // ============================================

  const hideNavbarPages = ['/login', '/register', '/feedback-login', '/feedbackadmin'];
  if (hideNavbarPages.includes(location.pathname)) {
    return null;
  }

  if (location.pathname === '/') {
    return null;
  }

  if (location.pathname.startsWith('/qr/')) {
    return null;
  }

  if (!isLoggedIn) {
    return (
      <nav className="navbar">
        <div className="nav-utility">
          <div className="nav-utility-container">
            <span className="utility-badge">
              <i className="fas fa-certificate"></i>
              ISO 9001:2015 &amp; 27001:2022
            </span>
            <div className="utility-links">
              <span>
                <i className="fas fa-phone"></i>
                <a href="tel:+917378707794">7378707794</a>
              </span>
              <span>
                <i className="fas fa-envelope"></i>
                <a href="mailto:contact@jmkinfosoft.com">contact@jmkinfosoft.com</a>
              </span>
            </div>
          </div>
        </div>
        <div className="nav-container">
          <div className="nav-brand" onClick={() => navigate('/')}>
            <i className="fas fa-shield-alt"></i>
            <span>JMK</span>
          </div>
          <button className="login-btn" onClick={() => navigate('/login')}>
            <i className="fas fa-sign-in-alt"></i> Login
          </button>
        </div>
      </nav>
    );
  }

  // ============================================
  // FULL NAVBAR FOR LOGGED IN USERS
  // ============================================
  return (
    <nav className="navbar">
      <div className="nav-utility">
        <div className="nav-utility-container">
          <span className="utility-badge">
            <i className="fas fa-certificate"></i>
            ISO 9001:2015 &amp; 27001:2022
          </span>
          <div className="utility-links">
            {/* <span>
              <i className="fas fa-phone"></i>
              <a href="tel:+917378707794">7378707794</a>
            </span> */}
            <span>
              <i className="fas fa-envelope"></i>
              <a href="mailto:contact@jmkinfosoft.com">contact@jmkinfosoft.com</a>
            </span>
          </div>
        </div>
      </div>

      <div className="nav-container">
        <div className="nav-brand" onClick={() => navigate('/')}>
          <i className="fas fa-shield-alt"></i>
          <span>JMK INFOSOFT</span>
        </div>

        {/* ✅ Updated: Using isActive function */}
        <div className="nav-links">
          {navButtons.map((btn, idx) => (
            <button
              key={idx}
              className={`nav-btn ${isActive(btn.path) ? 'active' : ''}`}
              onClick={() => navigateTo(btn.path)}
            >
              <i className={`fas ${btn.icon}`}></i>
              <span>{btn.label}</span>
            </button>
          ))}
        </div>

        <div className="nav-right">
          <span className="role-badge">
            <i className={`fas ${userRole === 'admin' ? 'fa-user-shield' : userRole === 'external_admin' ? 'fa-user-tie' : userRole === 'super_admin' ? 'fa-crown' : 'fa-user-graduate'}`}></i>
            {getRoleDisplay()}
          </span>

          <div className="dropdown">
            <button className="profile-btn" onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}>
              <span className="avatar">{userInitials}</span>
              <span className="uname">{userName}</span>
              <i className={`fas fa-chevron-${isProfileDropdownOpen ? 'up' : 'down'}`}></i>
            </button>

            {isProfileDropdownOpen && (
              <div className="dropdown-menu">
                <div className="dd-header">
                  <span className="dd-avatar">{userInitials}</span>
                  <div>
                    <div className="dd-name">{userName}</div>
                    <div className="dd-role">{getRoleDisplay()}</div>
                  </div>
                </div>

                <div className="dd-divider"></div>

                {userRole === 'candidate' && (
                  <button className="dd-item" onClick={() => navigateTo('/user')}>
                    <i className="fas fa-user"></i> Profile
                  </button>
                )}

                <div className="dd-divider"></div>

                <button className="dd-item logout" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt"></i> Sign Out
                </button>
              </div>
            )}
          </div>

          <button className="mobile-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </div>

      {/* ✅ Mobile menu updated */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <div className="mm-header">
            <span className="mm-avatar">{userInitials}</span>
            <div>
              <div className="mm-name">{userName}</div>
              <div className="mm-role">{getRoleDisplay()}</div>
            </div>
          </div>

          <div className="mm-divider"></div>

          {navButtons.map((btn, idx) => (
            <button key={idx} className={`mm-btn ${isActive(btn.path) ? 'active' : ''}`} onClick={() => navigateTo(btn.path)}>
              <i className={`fas ${btn.icon}`}></i> {btn.label}
            </button>
          ))}

          <div className="mm-divider"></div>

          {userRole === 'candidate' && (
            <>
              <button className="mm-btn" onClick={() => navigateTo('/user')}>
                <i className="fas fa-user"></i> Profile
              </button>
              <div className="mm-divider"></div>
            </>
          )}

          <button className="mm-logout" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i> Sign Out
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;